"use client";
import React, { useEffect, useRef, useState } from "react";
import { useModal } from "../Modal/ModalContext";
import QRCodeForm from "../QRCodeForm";
import { ALERT_TYPES, TRANSACTION_OPTIONS, WALLET_TYPES, WALLETS } from "../../utils/Enum";
import { AuthContainer, Container, Divider, FormWrap, InputGroup, OptionCard, SplitWrapper , SubmitButton, VideoBg } from "../SignUp/SignUpElements";
import axiosInstance from "../Authorization/client";
import { Button, CustomButton, HoverOption } from "../ButtonElement";
import AppBanner from "../AppBanner";
import { XummApp } from "../AppBanner/Data";
import OptionModal from "../OptionModal";
import xummLogo from "../../images/xumm_app_logo.png";
import walletConnectLogo from "../../images/wallet_connect_logo.jpg";
import crossmarkLogo from "../../images/crossmark_wallet_logo.png";
import gemWalletLogo from "../../images/gem_wallet_logo.png";
import joeyWalletLogo from "../../images/joey_wallet_logo.png";
import LoadingScreen, { ModalLoadingScreen } from "../LoadingScreen";
import { useWebsiteTheme } from "../WebsiteTheme/WebsiteThemeContext";
import { useAlert } from "../Alert/AlertContext";
import { Form, FormButton, FormButton1, FormContent1, FormGroup, FormH1, FormInput, FormInput1, FormLabel, FormText, FormWrapper } from "../CustomForm/CustomFormElements";
import { MenuButtonContent, MenuButtonDescription, MenuButtonIconWrapper, MenuButtonTitle, MenuGrid, MenuImage, MenuItemButton } from "../MenuOptions/MenuOptionsElements";
import { QrCode, QrWrapper, Small, Text, TextLink, TextRoute } from "../QRCodeForm/QrCodeFormElements";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MdEmail, MdWallet } from "react-icons/md";
import { getObjectLength, hexToStr } from "../../utils";
import { emailRegex } from "../../utils/Regex";
import sdk from '@crossmarkio/sdk'
import { useJoeyWallet } from "../../hooks/xrplAppKit/joeyWallet/JoeyWalletProvider";
import { useAuth } from "../../contexts/AuthContext";
import { JoeySendTransaction, XRPLSendTransaction } from "../QRCodeForm/WalletConnect/XRPLSendTransaction";
import { ContentWrapper } from "../../styles/main";
import { useUser } from "../../hooks/useUser";
import { getAddress, getPublicKey, isInstalled, signMessage, signTransaction } from "@gemwallet/api";
import { getSignTxStatus, updateSignTxStatus } from "../../utils/dbUtils/signTxUtils";
import { useXRPLWalletConnect } from "../../hooks/xrplAppKit/XRPLWalletProvider";
import { hashEmail } from "../GravatarAPI";
import Websocket from "react-websocket";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../Authorization/firebase";


const axios = axiosInstance

const Web3Login = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const walletParam = searchParams.get("wallet");
  const [selectedWallet, setSelectedWallet] = useState(walletParam);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 3. Sync state if the URL changes (e.g., browser back/forward buttons)
  /* useEffect(() => {
    if (walletParam !== selectedWallet) {
      setSelectedWallet(walletParam);
    }
  }, [walletParam, selectedWallet]); */

  // 4. Update both state and URL when a wallet is selected or cleared
  const handleWalletSelect = (walletId) => {
    setSelectedWallet(walletId);
    /* if (walletId) {
      setSearchParams({ wallet: walletId });
    } else {
      setSearchParams({}); // Clears the param to show the selector
    } */
  };

  // Map logos to IDs to avoid index errors when filtering
  const walletLogos = {
    [WALLET_TYPES.XAMAN]: xummLogo,
    [WALLET_TYPES.WALLET_CONNECT]: walletConnectLogo,
    [WALLET_TYPES.GEM_WALLET]: gemWalletLogo,
    [WALLET_TYPES.CROSSMARK]: crossmarkLogo,
    [WALLET_TYPES.JOEY_WALLET]: joeyWalletLogo,
  };

  // 2. Filter logic: Only Xaman and WalletConnect for mobile/tablets
  const availableWallets = isSmallScreen
    ? WALLETS.filter(
        (w) =>
          w.id === WALLET_TYPES.XAMAN || w.id === WALLET_TYPES.WALLET_CONNECT,
      )
    : WALLETS;

  if (!selectedWallet) {
    return (
      <FormWrap>
        <FormContent1>
          <Form onSubmit={(e) => e.preventDefault()}>
            <FormH1> Choose your Wallet </FormH1>
            <FormText>
              Select your preferred wallet to begin the registration process.
            </FormText>

            <MenuGrid
              style={{
                gridTemplateColumns: isSmallScreen ? "1fr" : "repeat(2, 1fr)",
                padding: "2%",
              }}
            >
              {availableWallets.map((wallet) => (
                <MenuItemButton
                  key={wallet.id}
                  onClick={() => {
                    handleWalletSelect(wallet.id);
                  }}
                >
                  <MenuButtonIconWrapper>
                    <MenuImage
                      style={{ borderRadius: "50%" }}
                      src={walletLogos[wallet.id]}
                    />
                  </MenuButtonIconWrapper>
                  <MenuButtonContent>
                    <MenuButtonTitle>{wallet.name}</MenuButtonTitle>

                    {/* 3. Hide descriptions on small screens */}
                    {!isSmallScreen && (
                      <MenuButtonDescription>
                        {wallet.description}
                      </MenuButtonDescription>
                    )}
                  </MenuButtonContent>
                </MenuItemButton>
              ))}
            </MenuGrid>
            <Small>
              New to web3 or the XRPL? Learn more about how to sign up{" "}
              <TextRoute to="/faq"> here</TextRoute>
            </Small>
            <Small>
              Already have an account?{" "}
              <TextRoute to="/signin">Sign in</TextRoute>
            </Small>
          </Form>
        </FormContent1>
      </FormWrap>
    );
  }
  return (
    <>
      {selectedWallet === WALLET_TYPES.XAMAN && (
        <XamanLogin onCancel={() => navigate(-1, { replace: true })} />
      )}
      {selectedWallet === WALLET_TYPES.WALLET_CONNECT && (
        <WalletConnectLogin
          onCancel={() => navigate(-1, { replace: true })}
        />
      )}
      {selectedWallet === WALLET_TYPES.JOEY_WALLET && (
        <JoeyWalletLogin
          onCancel={() => navigate(-1, { replace: true })}
        />
      )}
      {selectedWallet === WALLET_TYPES.GEM_WALLET && (
        <GemWalletLogin
          onCancel={() => navigate(-1, { replace: true })}
        />
      )}
      {selectedWallet === WALLET_TYPES.CROSSMARK && (
        <CrossMarkLogin
          onCancel={() => navigate(-1, { replace: true })}
        />
      )}
    </>
  );
};

const SignInTypeSelector = ({handleSignInType}) => {
  const navigate = useNavigate();
  const {addAlert} = useAlert()

      const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);
  
      useEffect(() => {
          const handleResize = () => setIsSmallScreen(window.innerWidth < 1024);
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
      }, []);



  // 4. Update both state and URL when a wallet is selected or cleared

   
        return (
          
           
              <Form onSubmit={(e) => e.preventDefault()} style={{alignSelf: 'center'}}>
                
                <MenuGrid
                  style={{ 
                      gridTemplateColumns: "repeat(3, 1fr)", 
                      padding: "2%" 
                  }}
                >
                  
                      <MenuItemButton
                        key={"emailPass"}
                        onClick={() => {
                          /* handleSignInType('email') */
                          addAlert({ type: ALERT_TYPES.INFO, title: "Coming Soon", secs: 10 });
                        }

                        }
                      >
                        <MenuButtonIconWrapper>
                          <MdEmail/>
                        </MenuButtonIconWrapper>
                        <MenuButtonContent>
                          <MenuButtonTitle>Email Login</MenuButtonTitle>
                          
                          
                              <MenuButtonDescription>
                                {"Create a traditional profile using your email credentials. Perfect for accessing your dashboard from any mobile or desktop browser using standard credential managers."}
                              </MenuButtonDescription>
                          
                        </MenuButtonContent>
                      </MenuItemButton>
{/* Visual Structural Separator */}
        <Divider>OR</Divider>
                      <MenuItemButton
                        key={"Web3"}
                        onClick={() => {
                          /* handleSignInType('web3') */
                          addAlert({ type: ALERT_TYPES.INFO, title: "Coming Soon", secs: 10 });
                        }

                        }
                      >
                        <MenuButtonIconWrapper>
                          <MdWallet/>
                        </MenuButtonIconWrapper>
                        <MenuButtonContent>
                          <MenuButtonTitle>Web3 Login</MenuButtonTitle>
                          
                          
                          
                              <MenuButtonDescription>
                                {"Authenticate securely using your crypto wallet. Enjoy an entirely passwordless experience, direct on-chain ownership initialization, and native marketplace interactions."}
                              </MenuButtonDescription>
                          
                        </MenuButtonContent>
                      </MenuItemButton>
                  
                </MenuGrid>
          </Form>
        
      
    );
  

};

const SignInPage = ({ onEmailSignIn, onWalletSignIn }) => {
  const { themeColors } = useWebsiteTheme();
  const { addAlert } = useAlert();
  
  // State for Web2 Form
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [next, setNext] = useState(false)
  const [loading, setLoading] = useState(false);
  const [signType, setSignType] = useState()

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      addAlert({
        title: "Missing Fields",
        type: ALERT_TYPES.DANGER,
        message: "Please fill in all credentials.",
      });
      return;
    }
    
    setLoading(true);
    try {
      await onEmailSignIn({ email, password });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleWalletSubmit = async () => {
    setLoading(true);
    try {
      await onWalletSignIn();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContainer>
     <FormH1 style={{ textAlign: "center" }}>Join Swerl</FormH1> 
     
     {!signType && <>
      <FormText style={{ textAlign: "center", color: themeColors.accentColor }}>
        Choose your preferred gateway to the next-gen payment ecosystem.
      </FormText>
    
      <SignInTypeSelector handleSignInType={setSignType} />
    </>}
    {signType === "email" && <>
        {/* Track 1: Standard Web2 Sign Up */}
        <Form onSubmit={handleEmailSubmit}>
          
           
            <FormH1 style={{ fontSize: "1.5rem", marginBottom: "10px" }}>
              Email Login
            </FormH1>
              <FormGroup style={{marginBottom: "2%"}} >
                <FormLabel>Email</FormLabel>
                <FormInput
                  style={{padding: "0.75rem 0.3rem"}}
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
               
              </FormGroup>
              <FormGroup>
                <FormLabel>Password</FormLabel>
                 <FormInput
                style={{padding: "0.75rem 0.3rem"}}
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
              </FormGroup>
    
              <FormButton
                as="button"
                type="submit"
                disabled={loading}
                style={{ width: "100%", marginTop: "10px", textAlign: "center" }}
              >
                {loading ? "Validating Credentials..." : "Sign In"}
              </FormButton>
        </Form></>}
       {signType === "web3" && (
               <>
                 {/* Track 2: Web3 Crypto Wallet Sign Up */}
                 {!next && (
                   <Form>
                     <div
                       style={{
                         display: "flex",
                         flexDirection: "column",
                         height: "100%",
                         justifyContent: "space-between",
                       }}
                     >
                       <div>
                         <FormH1 style={{ fontSize: "1.5rem", marginBottom: "10px" }}>
                           Web3 Identity
                         </FormH1>
                       </div>
       
                       <div>
                         <div
                           style={{
                             background: `${themeColors.warningColor}15`,
                             borderLeft: `4px solid ${themeColors.warningColor}`,
                             padding: "12px",
                             borderRadius: "4px",
                             marginBottom: "25px",
                           }}
                         >
                           <FormText
                             style={{
                               fontSize: "0.85rem",
                               fontWeight: "bold",
                               color: themeColors.secondaryBg,
                             }}
                           >
                             Requirements Note:
                           </FormText>
                           <FormText style={{ fontSize: "0.85rem", marginTop: "4px" }}>
                             You must have an{" "}
                             <strong>active, funded crypto wallet </strong> (like
                             Xaman, Gem Wallet, CrossMark, or Wallet Connect) installed
                             on your browser to complete initialization signatures.
                             Unfunded accounts cannot verify identity signatures
                             on-chain.
                           </FormText>
                         </div>
                       </div>
                     </div>
                     <SubmitButton
                       onClick={() => {
                         setNext(true);
                       }}
                     >
                       Continue
                     </SubmitButton>
                   </Form>
                 )}
                 {next && <Web3Login />}
               </>
             )}
      
    </AuthContainer>
  );
};


const XamanLogin = ({onCancel}) => {
    const [errMsg, setError] = useState()
    const [msg, setMessage] = useState('')
    const [invoice, setInvoice] = useState();
    const [status, setStatus] = useState("idle");
    const [response, setResponse] = useState({})  
    const [isLoaded, setLoaded] = useState(false)
    const [isOpened, setOpened] = useState(false)
    const [payload, setPayload] = useState()
    //const [isConfirmed, setConfirmed] = useState(false)
    const navigate  = useNavigate()
    const {login, currentUser} = useAuth()
    

    useEffect(() => {
      if(invoice){
            getSignTxStatus(invoice, status, setStatus, setResponse)
  
      }
      return () => {
      }
    }, [invoice])
    
    useEffect(() => {
      if(invoice){
        if(status === "success" && response !== false){
          VerifySignIn(response)
      }if(status === "error"){
        setLoaded(false);
        setPayload();
        setError(
          "The sign in failed. Reload the page and try again"
        );
      }}
      return () => {
  
      }
    }, [status, invoice])
  
    const SignIn = async () => {
       return await axios.get('/api/xummQrCode').then(res => {
          if (!res?.data?.error && res?.data?.payload) {
            setInvoice(res.data.invoice)
            setPayload(res.data.payload);
            setLoaded(true);
          } else {
            setError(
              "Oops! Something wrong happened. Reload the page"
            );
            setLoaded()
          }
          
        }).catch(err => {
          //console.log(err)
          setError('Oops! Something wrong happened. Reload the page')
          setLoaded()
          
        })
      };

    const updateSignInStatus = async (messageData) => {
        //console.log('Message Data: ', messageData)
        const data = JSON.parse(messageData);
        if (data.opened === true) {
          setOpened(true);
          setMessage("Wating for you to sign transaction");
        }
        if (isOpened === true && data.signed === true) {
          //VerifySignIn(payload.uuid);
          setLoaded(false)
          setError()
          //console.log("Signed")
        } else if (isOpened === true && data.signed === false) {
          setLoaded(false);
          setPayload({});
          setError(
            "The sign in was rejected. Reload the page and try again"
          );
        }
        if(data?.expired === true){
          setLoaded(false);
          setPayload();
          setError(
            "The transaction has expired. Reload the page and try again"
          );
          setOpened(false) 
          }
        if(data?.signed === false) {
          setLoaded(false);
          setPayload();
          setError(
            "The transaction was rejected. Reload the page and try again"
          );
          setOpened(false) 
        }
      };



        //Verify xumm payload sign in by user
  //Get users XRP address info (Email Hash and Account Data)
  const VerifySignIn = async ({address, userToken}) => {
    //console.log('uuid', uuid
    //console.log('address', address)
    localStorage.setItem('userToken',userToken)
    localStorage.setItem('accInfo', address)
    axios.get(`/api/userAddressInfo/${address}`).then(info => {
      
      let data = info.data
      if(data?.accInfo)
      {
        let accInfo = data.accInfo
        login(accInfo.email, address, accInfo.gravatarUrl).then(res => {
          if(res?.token)
        {
          signInWithCustomToken(auth, res.token ).then((user) => {
          localStorage.setItem('user', JSON.stringify(accInfo))
          navigate( '/home')
        }).catch(err => {
          //console.log(err)
          setError("Something went wrong. Reload the page")
        })}
        else{
          setError(res?.message)
        }
      }).catch(err => {
        //console.log(err)
        setError("Oops! Something wrong happened. Reload the page")
      })
        }
        else if(data === false)
      {
        setPayload()
        setLoaded()
        setError("No Email Address Detected. Add your email hash to your wallet and successfully sign up to continue")
      }
  }).catch(err => {
    //console.log(err)
    setLoaded(true)
    setError("Could not sign in. Ensure that credentials are valid")
  })

};

const validateTx = async() => {
  setLoaded(false)
  return await axios
        .post("/api/verifyTxPayload", { uuid: payload?.uuid }).then((verification) => {
          //console.log(verification)
          if(verification?.data && !verification?.data?.error)
          {
            setLoaded(false);
            //dispatch(verification?.data);
            getSignTxStatus(invoice, status, setStatus, setResponse)
            setPayload();
            setError("The transaction went through successfully.");
            setOpened(false); //console.log("Signed")
            return
          }else{
            setLoaded(true)
            setError("The transaction was not signed.");
            return
          }
        }).catch(err => {
          console.error(err)
          setLoaded(true)
          setError("Something went wrong. Try again");
        }) 
     
}

const refreshPage = () => {
  setPayload({});
  setError();
  setInvoice()
  setStatus("idle")
  setResponse()
  setOpened(false);
  setLoaded(false);
  SignIn();
};

  useEffect(() => {
    if(currentUser?.uid)
    {
      navigate( '/home')
    }else{
      SignIn()
    }
    
    setLoaded(false)
    setPayload({})
    setOpened(false)
    setError()
     
    return () => {}
    
  },[])
    
        //console.log("Websocket: ",payload.refs.websocket_status)
        return (
          <>
          
               {isLoaded === true && getObjectLength(payload) > 0 && !errMsg &&
               <><Websocket
                url={payload.refs.websocket_status}
                onMessage={(data) => updateSignInStatus(data)}
              />
                <FormWrap>
                  <FormContent1>
                    <Form action={(e) => e.preventDefault}>
                      <FormH1> Sign In </FormH1>
                      <QrWrapper>
                        <QrCode src={payload.refs.qr_png} />
                      </QrWrapper>
                      {isOpened === false && (
                        <Text>
                          Scan QR code or click {" "}
                          <TextLink href={payload.next.always} target="_blank" rel="noopener noreferrer">here</TextLink> to go
                          to your Xaman wallet
                        </Text>
                      )}
                      {isOpened === true && (
                        <Text>
                          <Text>{msg}</Text>
                        </Text>
                      )} 
                      <FormButton1 onClick={() => validateTx()} transparent>
                      I Already Signed Transaction
                    </FormButton1>
                    <FormButton1 transparent={false} to='/signin' onClick={refreshPage}>Reload</FormButton1>
                  <Small>Don't have an account? <TextRoute to='/signup'>Sign up</TextRoute></Small>
                    </Form>
                  </FormContent1>
                </FormWrap>
                </>
                }{errMsg && 
              
                 <FormWrap>
                  <FormContent1>
                    <Form>
                      <Text>{errMsg}</Text>
                      {errMsg?.includes("No Email Address Detected") && <>
                      <FormButton to='/signup' onClick={refreshPage}>Sign Up</FormButton>
                      <FormButton to='/setEmailHash' onClick={refreshPage}>Fix Email Hash</FormButton>
                      </>}
                      <FormButton1 transparent={true} to='/signin' onClick={refreshPage}>Reload</FormButton1>
                      
                    </Form>
                  </FormContent1>
                </FormWrap>
            }
            {!errMsg && !isLoaded && <LoadingScreen transparent={true} isLoaded={isLoaded} />}
            
            
          </>
        
           
          
        )
}

const WalletConnectLogin = ({onCancel}) => {
    const { session, setSession, account, setAccount, disconnect, connect, isReady} =
      useXRPLWalletConnect();
      const { toggleModal, modalContent, isOpen, closeModal, openModal } =
          useModal();
    const [errMsg, setError] = useState()
    const [msg, setMessage] = useState('')
    const [invoice, setInvoice] = useState();
    const [status, setStatus] = useState("idle");
    const [response, setResponse] = useState({})  
    const [isLoaded, setLoaded] = useState(false)
    const [isOpened, setOpened] = useState(false)
    const [payload, setPayload] = useState()
    //const [isConfirmed, setConfirmed] = useState(false)
    const navigate  = useNavigate()
    const {login, currentUser} = useAuth()
    


        
  //Get users XRP address info (Email Hash and Account Data)
  const VerifySignIn = async (address) => {
    //console.log('uuid', uuid
    setLoaded(false)
    localStorage.setItem('accInfo', address)
    localStorage.setItem('WalletType', WALLET_TYPES.WALLET_CONNECT)
    axios.get(`/api/userAddressInfo/${address}`).then(info => {
      
      let data = info.data
      if(data?.accInfo)
      {
        let accInfo = data.accInfo
        login(accInfo.email, address, accInfo.gravatarUrl).then(res => {
          if(res?.token)
        {
          signInWithCustomToken(auth, res.token ).then((user) => {
          localStorage.setItem('user', JSON.stringify(accInfo))
          localStorage.setItem('WalletType', WALLET_TYPES.WALLET_CONNECT)
          navigate( '/home')
        }).catch(err => {
          //console.log(err)
          setError("Something went wrong. Reload the page")
        })}
        else{
          setError(res?.message)
        }
      }).catch(err => {
        //console.log(err)
        setError("Oops! Something wrong happened. Reload the page")
      })
        }
        else if(data === false)
      {
        setPayload({})
        setLoaded(true)
        setError("No Email Address Detected. Add your email hash to your wallet and successfully sign up to continue")
      }
  }).catch(err => {
    console.error(err)
    setLoaded(true)
    setError("Could not sign in. Something went wrong")
  })

};

const signIn = () => {
  if(!session){
    setLoaded(true) 
    return 
  }
  let s = session;
   return axios.post(`/api/xrpl/createTransaction`, {
                        type: TRANSACTION_OPTIONS.SIGN_IN,
                        memo: 'User is signing the following transaction to gain access to the Sonar Muse platform',
                        txInfo: {
                          memo: 'User is signing the following transaction to gain access to the Sonar Muse platform',
                          type: TRANSACTION_OPTIONS.SIGN_IN,
                        },
                        sender: s?.namespaces?.xrpl?.accounts[0]?.split(":")[2],
                        walletType: WALLET_TYPES.WALLET_CONNECT,
                      })
                      .then((res) => {
                        // Switch the modal content to the Signer
                        setPayload(res.data.payload);
                        setInvoice(res.data.invoice);
                        setLoaded(true)
                        
                      })
                      .catch((err) => {
                        console.error(err)
                        setError("Something went wrong. Please reload and try again")
                      }
                    );
}

const refreshPage = () => {
  setPayload();
  setError();
  setOpened(false);
  setLoaded(false);
  signIn()
};

// Generate the payload once the user is connected via AppKit
  useEffect(() => {
    if (session && account && !payload && !isLoaded) {
      setLoaded(true);
     signIn()
    }
  }, [session, account, payload, isLoaded]);

  useEffect(() => {
    setLoaded(false)
    setPayload()
    setOpened(false)
    setError()
    if(currentUser?.uid)
    {
      navigate( '/home')
    }else{
      signIn()
    }
    
    
     
    return () => {}
    
  },[])
    
        //console.log("Websocket: ",payload.refs.websocket_status)
        return (
          <>
         
                {!session && (
                              <>
                                <FormWrap>
                                  <FormContent1>
                                    <Form action={(e) => e.preventDefault}>
                                      <FormH1> Sign In </FormH1>
                                      <FormButton1
                                        onClick={() => {
                                          connect()
                                        }
                                      } disabled={!isReady}
                                      >
                                        Connect Wallet
                                      </FormButton1>
                                      <br/>
                                       <FormButton1 transparent={false} to='/signin' onClick={refreshPage}>Reload</FormButton1>
                  <Small>Don't have an account? <TextRoute to='/signup'>Sign up</TextRoute></Small>
                  <Small>Have an artist account? Visit the <TextRoute
                  target="_blank"
                  rel="noopener noreferrer"
                   to='https://artists.sonarmuse.org'>Sonar Muse for Artists</TextRoute> portal to sign in</Small>
                                    </Form>
                                  </FormContent1>
                                </FormWrap>
                              </>
                            )}{errMsg && 
              
                <FormWrap>
                  <FormContent1>
                    <Form>
                      <Text>{errMsg}</Text>
                      {errMsg?.includes("No Email Address Detected") && <>
                      <FormButton to='/signup' onClick={refreshPage}>Sign Up</FormButton>
                      <FormButton to='/setEmailHash' onClick={refreshPage}>Fix Email Hash</FormButton>
                      </>}
                      <FormButton1 transparent={true}  onClick={refreshPage}>Reload</FormButton1>
                      
                    </Form>
                  </FormContent1>
                </FormWrap>
            }
             {!errMsg && isLoaded === true && session && getObjectLength(payload) > 0 && (
                            <>
                              <XRPLSendTransaction
                                heading={"Sign In"}
                                payload={payload}
                                topic={session?.topic}
                                account={
                                  session?.namespaces?.xrpl?.accounts[0]?.split(":")[2]
                                }
                                invoice={invoice}
                                method={"xrpl_signTransaction"}
                                onSuccess={VerifySignIn}
                                onFail={(value) => {
                                  setLoaded(false);
                                  setPayload();
                                  setResponse(value)
                                  setError(
                                     "The sign in has failed. Reload the page and try again",
                                  );
                                }}
                                body={{
                                  type: TRANSACTION_OPTIONS.SIGN_IN,
                                  sender: session?.namespaces?.xrpl?.accounts[0]?.split(":")[2],
                                  walletType: WALLET_TYPES.WALLET_CONNECT,
                                }}
                                type={TRANSACTION_OPTIONS.SIGN_IN}
                              />
                            </>
                          )}
            {!errMsg && !isLoaded && <LoadingScreen transparent={true} isLoaded={isLoaded} />}
           
            
          </>
        
           
          
        )
}

const JoeyWalletLogin = ({onCancel}) => {
    const { session, setSession, account, disconnect, connect, isReady, reconnect, actions, provider } =
      useJoeyWallet();
      const { toggleModal, modalContent, isOpen, closeModal, openModal } =
          useModal();
    const [errMsg, setError] = useState()
    const [msg, setMessage] = useState('')
    const [invoice, setInvoice] = useState();
    const [status, setStatus] = useState("idle");
    const [response, setResponse] = useState({})  
    const [isLoaded, setLoaded] = useState(false)
    const [isOpened, setOpened] = useState(false)
    const [payload, setPayload] = useState()
    //const [isConfirmed, setConfirmed] = useState(false)
    const navigate  = useNavigate()
    const {login, currentUser} = useAuth()


       
  //Get users XRP address info (Email Hash and Account Data)
  const VerifySignIn = async (address) => {
    //console.log('uuid', uuid
    setLoaded(false)
    localStorage.setItem('accInfo', address)
    localStorage.setItem('WalletType', WALLET_TYPES.WALLET_CONNECT)
    axios.get(`/api/userAddressInfo/${address}`).then(info => {
      
      let data = info.data
      if(data?.accInfo)
      {
        let accInfo = data.accInfo
        login(accInfo.email, address, accInfo.gravatarUrl).then(res => {
          if(res?.token)
        {
          signInWithCustomToken(auth, res.token ).then((user) => {
          localStorage.setItem('user', JSON.stringify(accInfo))
          localStorage.setItem('WalletType', WALLET_TYPES.JOEY_WALLET)
          navigate( '/home')
        }).catch(err => {
          //console.log(err)
          setError("Something went wrong. Reload the page")
        })}
        else{
          setError(res?.message)
        }
      }).catch(err => {
        //console.log(err)
        setError("Oops! Something wrong happened. Reload the page")
      })
        }
        else if(data === false)
      {
        setPayload({})
        setLoaded(true)
        setError("No Email Address Detected. Add your email hash to your wallet and successfully sign up to continue")
      }
  }).catch(err => {
    console.error(err)
    setLoaded(true)
    setError("Could not sign in. Something went wrong")
  })

};

const handleConnect = async () => {
    setLoaded(true);
    try {
      await connect();
      // On success, the session updates, triggering the useEffect above to fetch the payload
    } catch (err) {
      console.error("Connection error:", err);
      openModal()
      modalContent(<>
      <FormText>{Object(err).toString()}</FormText>
      <FormButton1 onClick={() => {
        closeModal()
        modalContent()
      }}>Ok</FormButton1>
      </>)
      setError("Failed to connect wallet. Please try again.");
    } finally {
      setLoaded(false);
    }
  };

const signIn = async () => {
  if(!session){
    setLoaded(true) 
    return 
  }
  let s = session
  
   return axios.post(`/api/xrpl/createTransaction`, {
                        type: TRANSACTION_OPTIONS.SIGN_IN,
                        memo: 'User is signing the following transaction to gain access to the Sonar Muse platform',
                        txInfo: {
                          memo: 'User is signing the following transaction to gain access to the Sonar Muse platform',
                          type: TRANSACTION_OPTIONS.SIGN_IN,
                        },
                        sender: account,
                        walletType: WALLET_TYPES.WALLET_CONNECT,
                      })
                      .then((res) => {
                        // Switch the modal content to the Signer
                        setPayload(res.data.payload);
                        setInvoice(res.data.invoice);
                        setLoaded(true)
                        
                      })
                      .catch((err) => {
                        console.error(err)
                        setError("Something went wrong. Please reload and try again")
                      }
                    );
}

const refreshPage = () => {
  setPayload();
  setError();
  setOpened(false);
  setLoaded(false);
  signIn()
};

// Generate the payload once the user is connected via AppKit
  useEffect(() => {
    if (session && account && !payload && !isLoaded) {
      
      setLoaded(true);
     signIn()
    
    }
  }, [session, account, payload, isLoaded, errMsg]);

  useEffect(() => {
  const autoReconnect = async () => {
    // If we have a session object but the connection isn't "active"
    if (session) {
      try {
        await reconnect(session);
      } catch (err) {
        console.error("Failed to auto-reconnect", err);
      }
    }
  };

  autoReconnect();
}, []);

  useEffect(() => {
    setLoaded(false)
    setPayload()
    setOpened(false)
    setError()
    if(currentUser?.uid)
    {
      navigate( '/home')
    }else{
      
      signIn();
    
    }
    
    
     
    return () => {}
    
  },[])
    
        //console.log("Websocket: ",payload.refs.websocket_status)
        return (
          <>
            
                {!session && (
                              <>
                                <FormWrap>
                                  <FormContent1>
                                    <Form action={(e) => e.preventDefault}>
                                      <FormH1> Sign In </FormH1>
                                      <FormButton1
                                        onClick={() => {
                                         handleConnect()
                                        }
                                      } disabled={!isReady}
                                      >
                                        Connect Wallet
                                      </FormButton1>
                                      <br/>
                                       <FormButton1 transparent={false}  onClick={refreshPage}>Reload</FormButton1>
                  <Small>Don't have an account? <TextRoute to='/signup'>Sign up</TextRoute></Small>
                  <Small>Have an artist account? Visit the <TextRoute
                  target="_blank"
                  rel="noopener noreferrer"
                   to='https://artists.sonarmuse.org'>Sonar Muse for Artists</TextRoute> portal to sign in</Small>
                                    </Form>
                                  </FormContent1>
                                </FormWrap>
                              </>
                            )}{errMsg && 
              
                 <FormWrap>
                  <FormContent1>
                    <Form>
                      <Text>{errMsg}</Text>
                      {errMsg?.includes("No Email Address Detected") && <>
                      <FormButton to='/signup' onClick={refreshPage}>Sign Up</FormButton>
                      <FormButton to='/setEmailHash' onClick={refreshPage}>Fix Email Hash</FormButton>
                      </>}
                      <FormButton1 transparent={true} onClick={refreshPage}>Reload</FormButton1>
                      
                    </Form>
                  </FormContent1>
                </FormWrap>
            }
             {!errMsg && isLoaded && session && payload &&  (
                            <>
                              <JoeySendTransaction
                                heading={"Sign In"}
                                payload={payload}
                                topic={session?.topic}
                                account={
                                  account
                                }
                                invoice={invoice}
                                method={"xrpl_signTransaction"}
                                onSuccess={VerifySignIn}
                                onFail={(value) => {
                                  setLoaded(false);
                                  setPayload();
                                  setResponse(value)
                                  setError(
                                     "The sign in has failed. Reload the page and try again",
                                  );
                                }}
                                cancel={onCancel}
                                body={{
                                  type: TRANSACTION_OPTIONS.SIGN_IN,
                                  sender: account,
                                  walletType: WALLET_TYPES.WALLET_CONNECT,
                                }}
                                type={TRANSACTION_OPTIONS.SIGN_IN}
                              />
                            </>
                          )}
            {!errMsg && !isLoaded && <LoadingScreen transparent={true} isLoaded={isLoaded} />}
            
          </>
        
           
          
        )
}

const 
GemWalletLogin = ({onCancel}) => {
    const [errMsg, setError] = useState()
    const [msg, setMessage] = useState('')
    const [invoice, setInvoice] = useState();
    const [status, setStatus] = useState("idle");
    const [response, setResponse] = useState({})  
    const [isLoaded, setLoaded] = useState(false)
    const [isOpened, setOpened] = useState(false)
    const [payload, setPayload] = useState()
    //const [isConfirmed, setConfirmed] = useState(false)
    const navigate  = useNavigate()
    const {login, currentUser} = useAuth()
    

    useEffect(() => {
      if(invoice){
            getSignTxStatus(invoice, status, setStatus, setResponse)
  
      }
      return () => {
      }
    }, [invoice])
    
    useEffect(() => {
      if(invoice){
        if(status === "success" && response !== false){
          VerifySignIn(response)
      }if(status === "error"){
        setLoaded(false);
        setPayload();
        setError(
          "The sign in failed. Reload the page and try again"
        );
      }}
      return () => {
  
      }
    }, [status, invoice])
  



        
  //Get users XRP address info (Email Hash and Account Data)
  const VerifySignIn = async ({address, userToken}) => {
    //console.log('uuid', uuid
    //console.log('address', address)
    localStorage.setItem('userToken',userToken)
    localStorage.setItem('accInfo', address)
    axios.get(`/api/userAddressInfo/${address}`).then(info => {
      
      let data = info.data
      if(data?.accInfo)
      {
        let accInfo = data.accInfo
        login(accInfo.email, address, accInfo.gravatarUrl).then(res => {
          if(res?.token)
        {
          signInWithCustomToken(auth, res.token ).then((user) => {
          localStorage.setItem('user', JSON.stringify(accInfo))
          localStorage.setItem('WalletType', WALLET_TYPES.GEM_WALLET)
          navigate( '/home')
        }).catch(err => {
          //console.log(err)
          setError("Something went wrong. Reload the page")
        })}
        else{
          setError(res?.message)
        }
      }).catch(err => {
        //console.log(err)
        setError("Oops! Something wrong happened. Reload the page")
      })
        }
        else if(data === false)
      {
        setPayload()
        setLoaded()
        setError("No Email Address Detected. Add your email hash to your wallet and successfully sign up to continue")
      }
  }).catch(err => {
    //console.log(err)
    setLoaded(true)
    setError("Could not sign in. Ensure that credentials are valid")
  })

};

 const signIn = async(pl) => {
    return isInstalled().then(async (response) => {
      if (response.result.isInstalled) {
    return signMessage(hexToStr(pl.payload.transaction.memo)).then(async (r) => {
      if( r?.result?.signedMessage){
  return await updateSignTxStatus(pl.invoice, {
              signature: r?.result?.signedMessage,
              isOffChain: true,
              ...r?.result,
              signed: true,
            })}else{
              setLoaded(false)
                      setError("Transaction Failed. Please reload and Try again")
                      await updateSignTxStatus(pl.invoice, {
              
              signed: false,
            })
            }
}).catch((err) => {
  console.error(err)
  setLoaded(false)
  setError(err)
});}else{
setError("No Wallet Found")
setLoaded(false)
}
      }).catch(err => {
        console.error(err)
        setError(err)
setLoaded(false)
      })

  }

      const handleConnect = () => {
        
          isInstalled().then((response) => {
            if (response.result.isInstalled) {
              getPublicKey().then(async(response) => {
                if(response.result?.address){
                 
                    return axios
                    .post(`/api/xrpl/createTransaction`, {
                      type: TRANSACTION_OPTIONS.SIGN_IN,
                      memo: 'User is signing the following transaction to sign up for the Sonar Muse platform',
                      sender: response.result?.address,
                      publicKey: response.result?.publicKey,
                      txInfo: {
                        memo: 'User is signing the following transaction to sign up for the Sonar Muse platform',
                        type: TRANSACTION_OPTIONS.SIGN_IN,
                        sender: response.result?.address,
                        publicKey: response.result?.publicKey,
                      },
                      walletType: WALLET_TYPES.GEM_WALLET,
                    })
                    .then(async (res) => {
                      // Switch the modal content to the Signer
                      setPayload(res.data.payload);
                      setInvoice(res.data.invoice);
                      setLoaded(true)
                      return await signIn(res.data)
                    })
                    .catch((err) => {
                      console.error(err)
                       setLoaded(false)
  const errorMessage = err?.message || "An unexpected error occurred during the transaction.";
  setError(errorMessage);
                    }
                  );
                }else{
                   setLoaded(false)
                  setError("Something went wrong. Please reload and try again")
                }
              });
            }
             
          }).catch(err => {
              console.error(err);
               setLoaded(false)
  const errorMessage = err?.message || "An unexpected error occurred during the transaction.";
  setError(errorMessage);
          });
      }

      


const refreshPage = () => {
  setPayload({});
  setError();
  setInvoice()
  setStatus("idle")
  setResponse()
  setOpened(false);
  setLoaded(false);
  handleConnect();
};

  useEffect(() => {
    if(currentUser?.uid)
    {
      navigate( '/home')
    }else{
      handleConnect()
    }
    
    setLoaded(false)
    setPayload({})
    setOpened(false)
    setError()
     
    return () => {}
    
  },[])
    
        //console.log("Websocket: ",payload.refs.websocket_status)
        return (
          <>
            
               {isLoaded === true &&
               <>
               <Form action={(e) => e.preventDefault}>
                                    <FormH1> Login </FormH1>
                                    <FormText
                      style={{
                        fontWeight: "bold",
                        marginBottom: "8px",
                      }}
                    >
                      Please open your wallet to sign the transaction.
                    </FormText>
                    <FormText>
                      Keep this page open while signing.
                    </FormText>
            
                    {/* BUTTON (Acts as Manual Retry if auto-trigger missed) */}
                    <FormButton1
                      onClick={handleConnect}
                      disabled={status === "processing"}
                    >
                      {status === "processing" ? "Processing..." : "Retry Transaction"}
                      {/* isWaiting
                        ? "Transaction didn't pop up? Click to Retry"
                        : "Confirm & Sign" */}
                    </FormButton1></Form>
                </>
                }{errMsg && 
              
                 <FormWrap>
                  <FormContent1>
                    <Form>
                      <Text>{errMsg}</Text>
                      {errMsg?.includes("No Email Address Detected") && <>
                      <FormButton to='/signup' onClick={refreshPage}>Sign Up</FormButton>
                      <FormButton to='/setEmailHash' onClick={refreshPage}>Fix Email Hash</FormButton>
                      </>}
                      <FormButton1 transparent={true} to='/signin' onClick={refreshPage}>Reload</FormButton1>
                      
                    </Form>
                  </FormContent1>
                </FormWrap>
            }
             {!isLoaded && ((!errMsg || errMsg?.length === 0) || (status === "loading" ||status === "processing")) && (
                          
                            <ModalLoadingScreen
                              text={(status === "loading" ||status === "processing") ? 'processing transaction. please wait' :"Loading. Please Wait..."}
                              transparent={true}
                            />
                         
                        )}
            
          </>
        
           
          
        )
}

const CrossMarkLogin = ({onCancel}) => {
    const {openModal, modalContent, closeModal} = useModal()
    const { themeColors } = useWebsiteTheme();
    const [errMsg, setError] = useState()
    const [msg, setMessage] = useState('')
    const [invoice, setInvoice] = useState();
    const [status, setStatus] = useState("idle");
    const [response, setResponse] = useState({})  
    const [isLoaded, setLoaded] = useState(false)
    const [isOpened, setOpened] = useState(false)
    const [payload, setPayload] = useState()
    //const [isConfirmed, setConfirmed] = useState(false)
    const navigate  = useNavigate()
    const {login, currentUser} = useAuth()
    


    useEffect(() => {
      if(invoice){
            getSignTxStatus(invoice, status, setStatus, setResponse)
  
      }
      return () => {
      }
    }, [invoice])
    
    useEffect(() => {
      if(invoice){
        if(status === "success" && response !== false){
          VerifySignIn(response)
      }if(status === "error"){
        setLoaded(false);
        setPayload();
        setError(
          "The sign in failed. Reload the page and try again"
        );
      }}
      return () => {
  
      }
    }, [status, invoice])
  



       
  //Get users XRP address info (Email Hash and Account Data)
  const VerifySignIn = async ({address, userToken}) => {
    //console.log('uuid', uuid
    //console.log('address', address)
    localStorage.setItem('userToken',userToken)
    localStorage.setItem('accInfo', address)
    axios.get(`/api/userAddressInfo/${address}`).then(info => {
      
      let data = info.data
      if(data?.accInfo)
      {
        let accInfo = data.accInfo
        login(accInfo.email, address, accInfo.gravatarUrl).then(res => {
          if(res?.token)
        {
          signInWithCustomToken(auth, res.token ).then((user) => {
          localStorage.setItem('user', JSON.stringify(accInfo))
          localStorage.setItem('WalletType', WALLET_TYPES.CROSSMARK)
          navigate( '/home')
        }).catch(err => {
          //console.log(err)
          setError("Something went wrong. Reload the page")
        })}
        else{
          setError(res?.message)
        }
      }).catch(err => {
        //console.log(err)
        setError("Oops! Something wrong happened. Reload the page")
      })
        }
        else if(data === false)
      {
        setPayload()
        setLoaded()
        setError("No Email Address Detected. Add your email hash to your wallet and successfully sign up to continue")
      }
  }).catch(err => {
    //console.log(err)
    setLoaded(true)
    setError("Could not sign in. Ensure that credentials are valid")
  })

};

 const signIn = async(pl) => {

      
    return await sdk.async.signInAndWait(pl.payload.memo).then(async ({ request, response, createdAt, resolvedAt }) => {
      closeModal()
       modalContent();
       if(response.data?.signature){
   await updateSignTxStatus(pl.invoice, {
              signature: response?.data?.signature,
              isOffChain: true,
              ...response.data,
              signed: true,
            })}
}).catch((err) => {
  console.error(err)
  setLoaded(false)
  setError(err)
});

  }

      const handleConnect = async () => {
        
         let isInstalled = await sdk.sync.isInstalled()
        if(isInstalled){
          await sdk.methods.signInAndWait().then(({request, response, createdAt, resolvedAt }) => {
                if(response?.data?.address){
                    return axios
                    .post(`/api/xrpl/createTransaction`, {
                      type: TRANSACTION_OPTIONS.SIGN_IN,
                      memo: 'User is signing the following transaction to sign up for the Sonar Muse platform',
                      sender: response?.data?.address,
                     publicKey: response?.data.publicKey,
                      txInfo: {
                        memo: 'User is signing the following transaction to sign up for the Sonar Muse platform',
                        type: TRANSACTION_OPTIONS.SIGN_IN,
                        sender: response?.data?.address,
                        publicKey: response?.data.publicKey,
                      },
                      walletType: WALLET_TYPES.CROSSMARK,
                    })
                    .then(async (res) => {
                      // Switch the modal content to the Signer
                      modalContent(<ModalLoadingScreen text={"Loading. Please Wait"} />);
                      setPayload(res.data.payload);
                      setInvoice(res.data.invoice);
                      setLoaded(false)
                      await signIn(res.data)
                    })
                    .catch((err) => {
                      console.error(err)
                      setError("Something went wrong. Please reload and try again")
                    }
                  );
                }
              })
        }
      }

      

const refreshPage = () => {
  setPayload({});
  setError();
  setInvoice()
  setStatus("idle")
  setResponse()
  setOpened(false);
  setLoaded(false);
  handleConnect();
};

  useEffect(() => {
    if(currentUser?.uid)
    {
      navigate( '/home')
    }else{
      handleConnect()
    }
    
    setLoaded(false)
    setPayload({})
    setOpened(false)
    setError()
     
    return () => {}
    
  },[])
    
        //console.log("Websocket: ",payload.refs.websocket_status)
        return (
          <>
            
               {isLoaded === true && getObjectLength(payload) > 0 && !errMsg &&
               <>
                 <Form action={(e) => e.preventDefault}>
                                    <FormH1> Login </FormH1>
                                    <FormText
                      style={{
                        fontWeight: "bold",
                        marginBottom: "8px",
                      }}
                    >
                      Please open your wallet to sign the transaction.
                    </FormText>
                    <FormText style={{ color: themeColors.accentColor }}>
                      Keep this page open while signing.
                    </FormText>
            
                    {/* BUTTON (Acts as Manual Retry if auto-trigger missed) */}
                    <FormButton1
                      to={"#"}
                      onClick={handleConnect}
                      disabled={status === "processing"}
                    >
                      {status === "processing" ? "Processing..." : "Retry Transaction"}
                      {/* isWaiting
                        ? "Transaction didn't pop up? Click to Retry"
                        : "Confirm & Sign" */}
                    </FormButton1></Form>
                </>
                }{errMsg && 
              
                <FormWrap>
                  <FormContent1>
                    <Form>
                      <Text>{errMsg}</Text>
                      {errMsg?.includes("No Email Address Detected") && <>
                      <FormButton to='/signup' onClick={refreshPage}>Sign Up</FormButton>
                      <FormButton to='/setEmailHash' onClick={refreshPage}>Fix Email Hash</FormButton>
                      </>}
                      <FormButton1 transparent={true} to='/signin' onClick={refreshPage}>Reload</FormButton1>
                      
                    </Form>
                  </FormContent1>
                </FormWrap>
            }
            {!errMsg && !isLoaded && <LoadingScreen transparent={true} isLoaded={isLoaded} />}
            
          </>
        
           
          
        )
}

export default SignInPage;
